import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal as AntModal } from 'antd';
import { CollectModalQuestion, CollectModalTitle } from '../ShareSummary.style';
import { ModalTopBg } from '@styles';
import { CashFilled} from '@assets';
import styled from 'styled-components';

const Modal = styled(AntModal)`

.ant-modal-content {
  padding-top: 110px !important;
}

#modal-icon {
  width: 116px !important;
  top: -16px !important;
}
`;

const CollectModal = ({
  open,
  loading,
  handleClose,
  onOk,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      centered
      destroyOnClose
      open={open}
      closable={false}
      width={320}
      confirmLoading={loading}
      cancelText={t("common.cancel")}
      onCancel={handleClose}
      okText={t('common.confirm')}
      onOk={onOk}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-around",
          alignItems: "center",
        }}
      >
        <ModalTopBg />
        <CashFilled id='modal-icon' />
        <CollectModalTitle> {t("share.collectModalTitle")} </CollectModalTitle>
        <CollectModalQuestion> {t("share.collectModalQuestion")} </CollectModalQuestion>
      </div>
    </Modal>
  )
}

export default CollectModal